import { css } from "@emotion/react";
import {
  HighlightOffTwoTone,
  Link as LinkIcon,
  Share,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { Theme, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";

import DatabaseMenuItem, {
  MenuItem,
} from "~/components/database/detail/database-content/database-menu/DialogMenuItem";
import { zIndex } from "~/components/database/detail/design";
import useIsSpMode, { SP_MODE_WIDTH } from "~/lib/client/hooks/useIsSpMode";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

type Props = {
  form: DatabaseDetailPageProps["form"];
  menuIsOpen: boolean;
  closeMenu: () => void;
  toggleMenu: () => void;
};

const DatabaseMenu = ({ menuIsOpen, closeMenu, toggleMenu, form }: Props) => (
  <div css={rootStyle}>
    <IconButton onClick={toggleMenu}>
      <MenuIcon />
    </IconButton>
    {menuIsOpen && (
      <>
        <div css={dialogButtonOverlayStyle} onClick={closeMenu} />
        <DatabaseMenuItemList closeMenu={closeMenu} form={form} />
      </>
    )}
  </div>
);

const rootStyle = css`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const dialogButtonOverlayStyle = css`
  width: 100vw;
  height: 100dvh;
  position: fixed;
  top: 0;
  left: 0;
`;

const MENU_ITEMS: MenuItem[] = [
  { icon: Share, text: "シェア", kind: "share" },
  { icon: LinkIcon, text: "リンクをコピー", kind: "copy-link" },
  { icon: HighlightOffTwoTone, text: "キャンセル", kind: "cancel" },
];

const DatabaseMenuItemList = ({
  closeMenu,
  form,
}: {
  closeMenu: () => void;
  form: DatabaseDetailPageProps["form"];
}) => {
  const theme = useTheme();
  const isSpMode = useIsSpMode();
  return (
    <div css={menuItemListStyle(theme)}>
      {MENU_ITEMS
        // SPModeが false なら Share を非表示
        .filter((item) => item.kind !== "share" || isSpMode)
        .map((item) => (
          <div css={menuItemContainerStyle(theme)} key={item.kind}>
            <DatabaseMenuItem item={item} closeMenu={closeMenu} form={form} />
          </div>
        ))}
    </div>
  );
};

const menuItemListStyle = (theme: Theme) => css`
  position: absolute;
  width: 10rem;
  background-color: ${theme.palette.background.default};
  border-radius: 0.5rem;
  filter: drop-shadow(1px 3px 5px rgba(0, 0, 0, 0.2));
  z-index: ${zIndex.menu};

  @media (max-width: ${SP_MODE_WIDTH}px) {
    top: 100%;
    right: 0;
  }

  @media (min-width: ${SP_MODE_WIDTH}px) {
    left: calc(100% + 4px);
    width: 10rem;
  }
`;

const menuItemContainerStyle = (theme: Theme) => css`
  &:not(:first-of-type) {
    border-top: 1px solid ${theme.palette.divider};
  }
`;

export default DatabaseMenu;
